import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find-index";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import { getBreadCrumbList, setTagNavListInLocalstorage, getMenuByRouter, getTagNavListFromLocalstorage, getHomeRoute, getNextRoute, routeHasExist, routeEqual, getRouteTitleHandled, localSave, localRead, getMenuByLocalRouter, getMenuByRouterRole } from '@/libs/util';
import Vue from 'vue';
import beforeClose from '@/router/before-close';
import { saveErrorLogger } from '@/api/data';
import router from '@/router';
import routers from '@/router/routers';
import config from '@/config';
import _menuList from '@/router/module/menu';
import { login_success_permission } from '../../api/auth';
var homeName = config.homeName; // 获取子项目的 route-list
// let allRoutes=[];
// if(process.env.NODE_ENV === 'production'){
//   console.log("获取子项目的router");
//   console.log(Vue.prototype.__share_pool__);
//   const childroutes = Vue.prototype.__share_pool__.routes;
//   if(childroutes){
//     for(let c in childroutes){
//       //判断是否是数组
//       if(Object.prototype.toString.call(childroutes[c])==='[object Array]'){
//         allRoutes.push(...childroutes[c]);
//       }else{
//         allRoutes.push(childroutes[c]);
//       }
//     }
//   }
// }else{
//   console.log("获取路由routers");
//   console.log(routers);
//   for(let i=0;i<routers.length;i++){
//     if(routers[i].name=='_home'){
//       allRoutes=routers[i].children;
//       break;
//     }
//   }
// }

var closePage = function closePage(state, route) {
  var nextRoute = getNextRoute(state.tagNavList, route);
  state.tagNavList = state.tagNavList.filter(function (item) {
    return !routeEqual(item, route);
  });
  router.push(nextRoute);
};

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    menuListData: [],
    hasReadErrorPage: false,
    homeName: 'salesDirector',
    //首页名称
    homeIndexList: [],
    //首页列表
    AllRoutes: [],
    //所有的微服务的菜单
    hasFullscreen: false
  },
  getters: {
    //menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    menuList: function menuList(state, getters, rootState) {
      return getMenuByRouterRole(state.menuListData, _menuList);
    },
    errorCount: function errorCount(state) {
      return state.errorList.length;
    }
  },
  mutations: {
    setFullscreen: function setFullscreen(state, b) {
      state.hasFullscreen = b;
    },

    /**
     * 设置首页名称list
     * @param state
     * @param homeIndex
     */
    setHomeIndexList: function setHomeIndexList(state, homeIndex) {
      if (homeIndex && homeIndex.length > 0) {
        for (var i = 0; i < homeIndex.length; i++) {
          var list = homeIndex[i];

          if (list.url === '/menumsg') {
            if (list.secondLevelMenu && list.secondLevelMenu.length > 0) {
              state.homeName = list.secondLevelMenu[0].url;
              state.homeIndexList = list.secondLevelMenu;
            }

            break;
          }
        }
      }
    },

    /**
     * 设置首页名称
     * @param state
     * @param homeName
     */
    setHomeName: function setHomeName(state, homeName) {
      state.homeName = homeName;
    },

    /**
     * 设置菜单
     */
    setmenuListData: function setmenuListData(state, menuList) {
      //获取所有的菜单 列表
      var allRoutes = [];
      state.AllRoutes = allRoutes;
      state.menuListData = menuList;
      localStorage.setItem("routesMenu", JSON.stringify(menuList));
    },
    setBreadCrumb: function setBreadCrumb(state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute);
    },
    setHomeRoute: function setHomeRoute(state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName);
    },
    setTagNavList: function setTagNavList(state, list) {
      var tagList = [];

      if (list) {
        tagList = _toConsumableArray(list);
      } else tagList = getTagNavListFromLocalstorage() || []; // if (tagList[0] && tagList[0].name !== homeName) tagList.shift()


      var homeTagIndex = tagList.findIndex(function (item) {
        return item.name === homeName;
      });

      if (homeTagIndex > 0) {
        var homeTag = tagList.splice(homeTagIndex, 1)[0];
        tagList.unshift(homeTag);
      }

      state.tagNavList = tagList;
      setTagNavListInLocalstorage(_toConsumableArray(tagList));
    },
    closeTag: function closeTag(state, route) {
      var tag = state.tagNavList.filter(function (item) {
        return routeEqual(item, route);
      });
      route = tag[0] ? tag[0] : null;
      if (!route) return;

      if (route.meta && route.meta.beforeCloseName && route.meta.beforeCloseName in beforeClose) {
        new Promise(beforeClose[route.meta.beforeCloseName]).then(function (close) {
          if (close) {
            closePage(state, route);
          }
        });
      } else {
        closePage(state, route);
      }
    },
    addTag: function addTag(state, _ref) {
      var route = _ref.route,
          _ref$type = _ref.type,
          type = _ref$type === void 0 ? 'unshift' : _ref$type;
      var router = getRouteTitleHandled(route);

      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router);else {
          if (router.name === homeName) state.tagNavList.unshift(router);else state.tagNavList.splice(1, 0, router);
        }
        setTagNavListInLocalstorage(_toConsumableArray(state.tagNavList));
      }
    },
    setLocal: function setLocal(state, lang) {
      localSave('local', lang);
      state.local = lang;
    },
    addError: function addError(state, error) {
      state.errorList.push(error);
    },
    setHasReadErrorLoggerStatus: function setHasReadErrorLoggerStatus(state) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      state.hasReadErrorPage = status;
    }
  },
  actions: {
    addErrorLog: function addErrorLog(_ref2, info) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState;
      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false);
      var _rootState$user = rootState.user,
          token = _rootState$user.token,
          userId = _rootState$user.userId,
          userName = _rootState$user.userName;

      var data = _objectSpread({}, info, {
        time: Date.parse(new Date()),
        token: token,
        userId: userId,
        userName: userName
      });

      saveErrorLogger(info).then(function () {
        commit('addError', data);
      });
    },

    /**
     * 获取菜单
     * @param commit
     * @param rootState
     * @param params
     * @returns {Promise<any>}
     */
    handleGetMenu: function handleGetMenu(_ref3, params) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;
      return new Promise(function (resolve, reject) {
        login_success_permission(params).then(function (res) {
          if (res.result === 0) {
            commit("setmenuListData", res.body); //commit("setHomeIndexList",res.data);

            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }
};